import { FullTalentQuestionDTOType, PlatformLocale } from '@/api/generated';

export enum VALIDATION_RULE_ENUM {
  ALPHANUMERIC = 'Alphanumeric',
  NUMERIC = 'Numeric',
  ID_NUMBER_ISRAEL = 'IdNumberIsrael',
  ID_NUMBER_MEXICO = 'IdNumberMexico'
}

export const OTHER_OPTION_ID = 'other';

export const MULTI_OPTION_TYPES = [
  FullTalentQuestionDTOType.RADIO,
  FullTalentQuestionDTOType.CHECKBOX,
  FullTalentQuestionDTOType.SELECT
] as FullTalentQuestionDTOType[];

export const DEFAULT_LANGUAGE_CODE = PlatformLocale['en-US'];
